module.exports = "\r\n<router-outlet></router-outlet>\r\n<footer></footer>\r\n\r\n\r\n\r\n\r\n\r\n"